import { defineStore } from 'pinia'

export const toastStore = defineStore('toast', {
  state: () => ({
    toastMessage: '',
    toastType: 'info',
    toastId: 0,
  }),
  actions: {
    success(message) {
      this.toastMessage = message
      this.toastType = 'success'
      this.toastId += 1
    },
    error(message) {
      this.toastMessage = message
      this.toastType = 'error'
      this.toastId += 1
    },
    clear() {
      this.toastMessage = ''
    }
  },
})